import { AssistantOutlined } from '@/shared/ui/icons';
import { Box } from '@/shared/ui/layout/Box';
import Button from '@/shared/ui/primitives/Button';
import { Tag } from '@/shared/ui/primitives/Tag';

const AskGXButton = ({
  onClick
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Button
      color='primary'
      size='large'
      startIcon={<AssistantOutlined />}
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 250
      }}
      variant='contained'
      onClick={onClick}
    >
      GX Go Assistant
      <Box
        sx={{
          ml: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Tag />
      </Box>
    </Button>
  );
};

export default AskGXButton;
